import { Pipe, PipeTransform } from '@angular/core';
import { SessionBookingVM } from '../models/SessionBookingVM';
import * as moment from 'moment-timezone';

@Pipe({ name: 'sessionclienttime' })
export class SessionClientTimePipe implements PipeTransform {
  transform(value: SessionBookingVM, args: string[]): any {
    var counsellorTimeZone = moment.tz(moment(value.date).format('YYYY-MM-DD'), value.counsellorTZAtBooking.zoneName);
    var clientTimeZone = counsellorTimeZone.tz(moment.tz.guess());
    return clientTimeZone.format('HH:mm');
  }
}
